import React from 'react';
import '../../news-pages.css'
import Parse from 'html-react-parser'

import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

import cover from './cover.jpg'
import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg'
import pic3 from './pic3.jpg'
import pic4 from './pic4.jpg'
import pic5 from './pic5.jpg'
import pic6 from './pic6.jpg'
import pic7 from './pic7.jpg'
import pic8 from './pic8.jpg'
import pic9 from './pic9.jpg'
import pic10 from './pic10.jpg'
import pic11 from './pic11.jpg'
import pic12 from './pic12.jpg'
import pic13 from './pic13.jpg'
import pic14 from './pic14.jpg'

const Page = () => {

    const detail = 
        {
            id:1,
            imgSrc:cover,
            ini:'The Faculty of Associated Medical Sciences, CMU, welcomed executives from IRD, France.',
            href:'',
            element:'',
            topic:'',
            inform: `Professor Dr. Sakorn Pornprasert, Dean of the Faculty of Associated Medical Sciences, Chiang Mai University, along with the executive team and faculty members, welcomed Dr. Philippe Charvis, Deputy Director for Science of the French National Research Institute for Sustainable Development (IRD), and Dr. Xavier Mari, IRD Representative in Thailand, on Wednesday, May 13, 2026. The meeting was held at the Department of Radiologic Technology, Building 2.<br>The visit focused on discussing academic collaborations and monitoring the progress of the IJL PRESTO international research project, supported by the IRD. Following the discussion, the IRD executives visited the LUCENT International Collaboration Laboratory at the Integrated Academic Excellence Center (IAEC) building. The visit aimed to showcase the faculty’s research infrastructure and its readiness to drive global health research through sustainable international partnerships.`,
            link1: `https://www.facebook.com/permalink.php?story_fbid=pfbid029CHQPxePn8JYGyqY2u8WMGufPfUKGamNjxwuCHMtpbyzwLzEmNoBoAnvjXUNpqh4l&id=100089824854973`,
        }
    
        const handleLink1 = () =>{
            window.open(detail.link1, '_blank', 'noreferrer')
        }

    const imgs = [
        {
            imageSrc: cover,
            alt: 'cover',
            title: 'cover',
            thumbnailImageSrc: cover
        },
        {
            imageSrc: pic1,
            alt: 'pic1',
            title: 'pic1',
            thumbnailImageSrc: pic1
        },
        {
            imageSrc: pic2,
            alt: 'pic2',
            title: 'pic2',
            thumbnailImageSrc: pic2
        },
        {
            imageSrc: pic3,
            alt: 'pic3',
            title: 'pic3',
            thumbnailImageSrc: pic3
        },
        {
            imageSrc: pic4,
            alt: 'pic4',
            title: 'pic4',
            thumbnailImageSrc: pic4
        },
        {
            imageSrc: pic5,
            alt: 'pic5',
            title: 'pic5',
            thumbnailImageSrc: pic5
        },
        {
            imageSrc: pic6,
            alt: 'pic6',
            title: 'pic6',
            thumbnailImageSrc: pic6
        },
        {
            imageSrc: pic7,
            alt: 'pic7',
            title: 'pic7',
            thumbnailImageSrc: pic7
        },
        {
            imageSrc: pic8,
            alt: 'pic8',
            title: 'pic8',
            thumbnailImageSrc: pic8
        },
        {
            imageSrc: pic9,
            alt: 'pic9',
            title: 'pic9',
            thumbnailImageSrc: pic9
        },
        {
            imageSrc: pic10,
            alt: 'pic10',
            title: 'pic10',
            thumbnailImageSrc: pic10
        },
        {
            imageSrc: pic11,
            alt: 'pic11',
            title: 'pic11',
            thumbnailImageSrc: pic11
        },
        {
            imageSrc: pic12,
            alt: 'pic12',
            title: 'pic12',
            thumbnailImageSrc: pic12
        },
        {
            imageSrc: pic13,
            alt: 'pic13',
            title: 'pic13',
            thumbnailImageSrc: pic13
        },
        {
            imageSrc: pic14,
            alt: 'pic14',
            title: 'pic14',
            thumbnailImageSrc: pic14
        },
    ]

    return (
        <div className='elements containers'>
            <div className="img-slicer">
                <OwlCarousel
                    className='owl-theme'
                    loop={true}
                    margin={10}
                    lazyLoad={true}
                    nav
                    items={1}
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    smartSpeed={1000}
                >
                    {imgs.map((img,index)=>(
                        <div className="item" key={index}><img src={img.imageSrc} alt="item" /></div>
                    ))}
                </OwlCarousel>
            </div>
            <div className="text">
                <h1>{detail.ini}</h1>
                <h2>{Parse(detail.topic)}</h2>
                <p>{Parse(detail.inform)}</p>
                <div className="btn">
                    <h2>MORE INFORMATION</h2>
                    <button onClick={handleLink1}>{detail.link1}</button>
                </div>
            </div>
        </div>
    );
}

export default Page;
